import {Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {TtLiveActivityEntry} from '../../interfaces/time-tracking/tt-live-activity-entry';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {TtLiveActivityEntryFactory} from '../../factories/time-tracking/tt-live-activity-entry-factory';

@Injectable({
  providedIn: 'root'
})
export class TtLiveActivityEntriesTable extends SyncTable<TtLiveActivityEntry> {
  constructor() {
    super(db.ttLiveActivityEntries);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<TtLiveActivityEntry>({
        api: ['tt-live-activity-entries'],
        fromObject: TtLiveActivityEntryFactory.fromObject,
        toRemote: TtLiveActivityEntryFactory.toRemote
      })
    };
  }

  public async removeAll(): Promise<void> {
    const ttLiveActivityEntries = await this.getAll();
    await this.removeMany(ttLiveActivityEntries.map(_ttLiveActivityEntry => _ttLiveActivityEntry.uuid));
  }
}
